module.exports = __webpack_public_path__ + "static/media/bg_sj.f66e30e8.png";